import { Pipe, PipeTransform } from '@angular/core';

import { UserService } from '../../core/services/user.service';

@Pipe({
  name: 'accessManagement'
})
export class AccessManagementPipe implements PipeTransform {

  constructor(private userService: UserService) { }

  transform(requiredAccessList: string[], type: 'ALL' | 'ANY'): boolean {
    if (this.userService.getUserProfile && this.userService.isAuthenticated) {
      const userAccessList = [this.userService.getUserRole, ...this.userService.getUserPrivilegesList];
      if (type === 'ANY') {
        return requiredAccessList.some((access: string) => userAccessList.includes(access));
      } else {
        return requiredAccessList.every((access: string) => userAccessList.includes(access));
      }
    } else {
      return false;
    }
  }

}
